module.exports = __webpack_public_path__ + "media/assets/images/votorantim-banco-627c7c3851fa8ad87d0ab2cbaeda1ee7.png";